

import SearchQueryId from '../../shared/gqlIds/SearchQueryId'
import createProxyRecord from './createProxyRecord'
import initHandler from './initHandler'

const defaults = [
  {
    service: 'jira',
    meetingPropName: 'jiraSearchQuery',
    type: 'JiraSearchQuery',
    defaultQuery: {
      queryString: '',
      projectKeyFilters: [] ,
      isJQL: false
    }
  },
  {
    service: 'jiraServer',
    meetingPropName: 'jiraServerSearchQuery',
    type: 'JiraSearchQuery',
    defaultQuery: {
      queryString: '',
      projectKeyFilters: [] ,
      isJQL: false
    }
  },
  {
    service: 'PARABOL',
    meetingPropName: 'parabolSearchQuery',
    type: 'ParabolSearchQuery',
    defaultQuery: {
      queryString: '',
      statusFilters: ['active'] 
    }
  },
  {
    service: 'github',
    meetingPropName: 'githubSearchQuery',
    type: 'GitHubSearchQuery',
    defaultQuery: {
      queryString: ''
    }
  },
  {
    service: 'azureDevOps',
    meetingPropName: 'azureDevOpsSearchQuery',
    type: 'AzureDevOpsSearchQuery',
    defaultQuery: {
      queryString: '',
      projectKeyFilters: [] ,
      isWIQL: false
    }
  },
  {
    service: 'gitlab',
    meetingPropName: 'gitlabSearchQuery',
    type: 'GitLabSearchQuery',
    defaultQuery: {
      queryString: '',
      selectedProjectsIds: [] 
    }
  },
  {
    service: 'linear',
    meetingPropName: 'linearSearchQuery',
    type: 'LinearSearchQuery',
    defaultQuery: {
      queryString: '',
      selectedProjectsIds: [] 
    }
  }
] 

const LocalPokerHandler = {
  update(store, payload) {
    initHandler(store, payload)
    const meetingId = payload.dataID
    const meeting = store.get(meetingId)
    defaults.forEach(({service, type, meetingPropName, defaultQuery}) => {
      const queryId = SearchQueryId.join(service, meetingId)
      const existingQuery = store.get(queryId)
      if (existingQuery) return
      const newQuery = createProxyRecord(store, type, {
        id: queryId,
        ...defaultQuery
      })
      meeting.setLinkedRecord(newQuery, meetingPropName)
    })
  }
}

export default LocalPokerHandler
